import React from 'react';
import { EnvelopeIcon, LinkIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';

const ShareButtons = ({ url, title }) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const shareLinks = [
    {
      name: 'Facebook',
      icon: (
          <svg fill="currentColor" viewBox="0 0 24 24" className="w-4 h-4">
            <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
          </svg>
      ),
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      bg: 'bg-[#1877F2]',
      hover: 'hover:bg-[#0d65d9]'
    },
    {
      name: 'X (Twitter)',
      icon: (
          <svg fill="currentColor" viewBox="0 0 24 24" className="w-3.5 h-3.5">
            <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932 6.064-6.932zm-1.292 19.494h2.039L6.486 3.24H4.298l13.311 17.407z" />
          </svg>
      ),
      href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
      bg: 'bg-black',
      hover: 'hover:bg-gray-800'
    },
    {
      name: 'LinkedIn',
      icon: (
          <svg fill="currentColor" viewBox="0 0 24 24" className="w-4 h-4">
            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
          </svg>
      ),
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      bg: 'bg-[#0077B5]',
      hover: 'hover:bg-[#005a87]'
    },
    {
      name: 'Email',
      icon: <EnvelopeIcon className="w-4 h-4 text-white" />,
      href: `mailto:?subject=${encodedTitle}&body=${encodedUrl}`,
      bg: 'bg-indigo-500',
      hover: 'hover:bg-indigo-600'
    }
  ];

  const copyToClipboard = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url);
      toast.success('Link copied to clipboard!');
    }
  };

  return (
      <div className="flex items-center gap-3 py-1" onClick={(e) => e.stopPropagation()}>
        <span className="text-xl font-bold text-gray-900 mr-1">Share:</span>
        <div className="flex items-center gap-2">
          {shareLinks.map((link) => (
              <a
                  key={link.name}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`flex items-center justify-center w-8 h-8 rounded-full text-white transition-all shadow-sm transform hover:scale-110 ${link.bg} ${link.hover}`}
                  title={`Share on ${link.name}`}
                  onClick={(e) => e.stopPropagation()}
              >
                {link.icon}
              </a>
          ))}
          <button
              onClick={copyToClipboard}
              className="flex items-center justify-center w-8 h-8 rounded-full text-white bg-gray-400 hover:bg-gray-500 transition-all shadow-sm transform hover:scale-110"
              title="Copy link"
          >
            <LinkIcon className="w-4 h-4" />
          </button>
        </div>
      </div>
  );
};

export default ShareButtons;